import React from "react";

function Yourteam() {
  return <div>Yourteam</div>;
}

export default Yourteam;
